import { render } from "./InputPropsCmp.vue?vue&type=template&id=30148486"
import script from "./InputPropsCmp.vue?vue&type=script&lang=js"
export * from "./InputPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__